import { render, staticRenderFns } from "./EventBankAccount.vue?vue&type=template&id=5f944e17&scoped=true"
import script from "./EventBankAccount.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventBankAccount.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EventBankAccount.vue?vue&type=style&index=0&id=5f944e17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f944e17",
  null
  
)

export default component.exports